import { Component, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import { ChatRecommenderState, OutPutItem, RecommendationServicesService } from '../../services/recommendation-services.service';
import { NbCardModule } from '@nebular/theme';
import { OutputItemsComponent } from './output-items/output-items.component';
import { SequentialOutputAnimationDirective } from './sequential-output-animation.directive';
import { FacilitiesModule } from '@urbannex/pms';

export interface StreamContent {
  header: string;
  description: string;
  items: string[];
}
@Component({
  selector: 'ubs-output-panel',
  standalone: true,
  imports: [CommonModule,NbCardModule,OutputItemsComponent,SequentialOutputAnimationDirective],
  templateUrl: './output-panel.component.html',
  styleUrls: ['./output-panel.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class OutputPanelComponent implements OnInit, OnChanges, OnDestroy {
  @Input() content!: StreamContent; 
  @ViewChildren(OutputItemsComponent) outputItemComponents!: QueryList<OutputItemsComponent>;
  header = '';
  description = '';
  outPutItems:OutPutItem[] = [];
  visibleItems: string[] = [];
  isLoading = true;
  private cleanup: (() => void)[] = [];

  readonly hasSelections$ = this.chatRecommenderState.hasSelections$;
  readonly isSelected$ = this.chatRecommenderState.isSelected$;
  readonly desription$ = this.chatRecommenderState.outPutDescription$;
  readonly header$ = this.chatRecommenderState.outPutHeader$;
  readonly items$ = this.chatRecommenderState.outPutItems$;

  readonly vm$ = this.chatRecommenderState.state$;

  // Track which item is currently animating
  currentAnimatingIndex = -1;
  isAnimationRunning = false;

  animationComplete = false;

  @ViewChild(SequentialOutputAnimationDirective, { static: false }) 
  animationDirective!: SequentialOutputAnimationDirective;

  constructor(private chatRecommenderState: RecommendationServicesService) {
    // Initialize the component state or perform any setup here

    /* this.header$.subscribe((header: string) => {
      this.header = header;
    });
    this.desription$.subscribe((description: string) => {
      this.description = description;
    });
    this.items$.subscribe((items: OutPutItem[]) => {
      this.outPutItems = items;
      //this.visibleItems = items;
    }); */
  }
  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit() {
    this.vm$.subscribe((state) => {
        //await this.streamContent(state);
        this.header = state.outPutHeader;
        this.description = state.outPutDescription;
        this.outPutItems = state.outPutItems;
        this.animationComplete = false;
        // Reset any animation state 
        setTimeout(() => {
          this.animateItems();
        });
      });
  }

  
  private async streamContent(content: ChatRecommenderState) {
    // Stream header
    //await this.delay(300);
    this.header = content.outPutHeader;
    
    // Stream description
    //await this.delay(800);
    this.description = content.outPutDescription;
    
    // Stream items
   // await this.delay(800);
    this.outPutItems = content.outPutItems;
    /* for (const item of content.items) {
      await this.delay(800);
      this.visibleItems = [...this.visibleItems, item];
    } */
   this.animateItems();
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => {
      const timer = setTimeout(() => resolve(), ms);
      this.cleanup.push(() => clearTimeout(timer));
    });
  }

  ngOnDestroy() {
    this.cleanup.forEach(clean => clean());
  }

  // Trigger the animation sequence
  animateItems(): void {
    // This method triggers the directive to start the animation
    // The directive will handle the sequencing
    /* if (this.animationDirective) {
      this.animationDirective.startAnimationSequence();
    } */
  }
  
  // Handle animation sequence completion
  onAnimationSequenceComplete(): void {
    console.log('All animations complete!');
    this.isLoading = false;
    // You can trigger any follow-up actions here
  }

}
